import { isEmpty } from 'lodash-es'

import { EmbroiderableProductEmbroideryRestrictions } from '../../../types/graphql/product'

export const isEmbroideryFontAllowedForProduct = ({
  fontKey,
  productEmbroideryConfig,
}: {
  fontKey: string
  productEmbroideryConfig: EmbroiderableProductEmbroideryRestrictions
}) => {
  if (isEmpty(productEmbroideryConfig.fontRestrictions)) return true
  return !!productEmbroideryConfig.fontRestrictions.find(font => font.key === fontKey)
}
